module.exports = __webpack_public_path__ + "img/tasks.417002de.svg";